import { createContext, HTMLAttributes, MouseEventHandler, useContext, useMemo } from "react"

interface DateRangeInputContextValue {
  onClear?: MouseEventHandler<HTMLButtonElement>
}

interface DateRangeInputProviderProps extends HTMLAttributes<HTMLElement> {
  onClear?: MouseEventHandler<HTMLButtonElement>
}

export const DateRangeInputContext = createContext<DateRangeInputContextValue>({})

export const DateRangeInputProvider = ({ onClear, children }: DateRangeInputProviderProps) => {
  const value = useMemo(
    () => ({
      onClear,
    }),
    [onClear],
  )

  return <DateRangeInputContext.Provider value={value}>{children}</DateRangeInputContext.Provider>
}

export const useDateRangeInputContext = () => {
  return useContext(DateRangeInputContext)
}
